<aside class="sidebar" [class.close]="isMenuClosed">
  <div class="sidebar-header show md:hidden">
    <h1 class="logo">
      <a routerLink="/" title="Logo"><img src="/assets/images/logo.png" alt="Logo" /></a>
    </h1>
    <div class="btnClose">
      <button mat-icon-button (click)="toggleMenu()">
        <mat-icon class="closeIcon">{{ isMenuClosed ? 'menu' : 'close' }}</mat-icon>
      </button>
    </div>
   
  </div>
  <!-- Desktop Navigation -->
  <nav class="always-visible-nav">
    <ul>
      <li *ngFor="let link of navLinks">
        <a [routerLink]="link.path" routerLinkActive="active" class="menu-link">
          {{ link.title }}
        </a>
      </li>
    </ul>
  </nav>

  <!-- Mobile Navigation -->
  <nav class="mobile-nav">
    <ul class="internal">
      <li *ngFor="let link of navLinks">
        <a [routerLink]="link.path" routerLinkActive="active" (click)="closeMenu()" class="menu-link">
          {{ link.title }}
        </a>
      </li>
    </ul>
    <ul class="external">
      <!-- Mobile-Only Links -->
      <li *ngFor="let link of mobileOnlyLinks">
        <a
          [href]="link.path"
          [target]="link.target"
          (click)="closeMenu()"
          class="menu-link"
          (click)="link.title === 'Contact Us' ? openModal($event) : null">
                 {{ link.title }}
        </a>
      </li>
    </ul>
  </nav>


</aside>